import GetNewsAPI from "./getNewsAPI";

const GetNewsService = async (id?: string): Promise<any> => {
  try {
    return await GetNewsAPI(id);
  } catch (error) {
    throw error;
  }
};

export default GetNewsService;